/**
 * Convierte los fallos de carga de chunks (import dinámico de ruta / preload de
 * Vite) en una pantalla `error.vue` renderizada, en vez de dejar la pantalla en
 * blanco. Causa típica: tras un deploy, el `index.html` cacheado por la PWA pide
 * chunks que ya devuelven 404; o red intermitente. Regla G-245.
 *
 * NO recarga solo (regla pwa-update): `error.vue` ofrece el botón "Recargar".
 *
 * El `vueApp.config.errorHandler` (slot único, G-UX-007) lo extiende
 * `plugins/vue-unmount-error.client.ts` para el mismo fin en errores de runtime.
 */
import { isChunkLoadError } from '~/utils/isChunkLoadError'

export default defineNuxtPlugin(() => {
  function showLoadError(cause: unknown) {
    showError(createError({
      fatal: true,
      statusCode: 503,
      statusMessage: 'No se pudo cargar la página',
      // Conserva el mensaje original para que la detección de conexión de error.vue dispare.
      message: cause instanceof Error ? cause.message : String(cause),
    }))
  }

  // 1) Fallo al navegar a una ruta cuyo chunk no carga.
  const router = useRouter()
  router.onError((err) => {
    if (isChunkLoadError(err)) showLoadError(err)
  })

  // 2) Preload de chunk/CSS falla (evento de Vite en window). Este evento es
  //    exclusivo de fallos de preload, así que cualquier ocurrencia es un fallo de
  //    chunk. preventDefault evita el rechazo no manejado que dejaría pantalla blanca.
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    showLoadError((event as unknown as { payload?: unknown }).payload ?? new Error('vite:preloadError'))
  })
})
